import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_converted_weightService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { inputWeight: number, fromUOM: number, toUOM: number }): Promise<{ result?: { ConvertedWeight?: number } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inputWeight)) {
      $missingRequiredInParams.push('\'inputWeight\'');
    }
    if (isNil($inParams.fromUOM)) {
      $missingRequiredInParams.push('\'fromUOM\'');
    }
    if (isNil($inParams.toUOM)) {
      $missingRequiredInParams.push('\'toUOM\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      inputWeight: number, fromUOM: number, toUOM: number    }) {
        if(isNil($inParams.inputWeight)) {
          return true; 
        }
        if(isNil($inParams.fromUOM)) {
          return true; 
        }
        if(isNil($inParams.toUOM)) {
          return true; 
        }
      return false;
    }
}
